// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"1924": "2bcbcde1","2523": "a72694b1","5242": "a72694b1","7187": "856f706d",}[chunkId] + ".css"
}